import './NavBar.css'
import { Stack } from "@mui/material";
import { Link } from "react-router-dom";

import { SearchBar } from "./";

const Navbar = () => (
  <Stack
    direction="row"
    alignItems="center"
    p={2}
    sx={{
      position: "sticky",
      background: "#000",
      top: 0,
      justifyContent: "space-between",
    }}
  >
    <Link to="/" style={{ display: "flex", alignItems: "center" }}>
      <div className="logo">
        <span className="logo-text">VIDELLIA</span>
        <span className="by-ajay">by Ajay</span>
      </div>
    </Link>
    <SearchBar />
  </Stack>
);

export default Navbar;
